import { useEffect, useState } from "react";
import { authCRUD } from "../../../actions/auth";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import { UserAdd } from "./add";
import {
  Button,
  Dropdown,
  Space,
} from "antd";
import {
  MoreOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export const UserContent = () => {
  const [open, setOpen] = useState(false);
  const [openRole, setOpenRole] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [userId, setUserId] = useState("")
  const navigate = useNavigate()


  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      authCRUD
        .loadUserList(postsPerPage, nextPage, value, 'first_name')
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false);
        });
    });
  }, [page, postsPerPage, value, index, nextPage]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 100,
    },
    {
      key: "full_name",
      title: "Full Name",
      dataIndex: "full_name",
      sortable: true,
      flexGrow: 1,
    },

    {
      key: "gender",
      title: "Gender",
      dataIndex: "gender",
      sortable: true,
      width: 100,
    },
    {
      key: "email",
      title: "Email Address",
      dataIndex: "email",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "phone",
      title: "Phone Number",
      dataIndex: "phone",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "last",
      title: "Last Login",
      dataIndex: "last",
      sortable: true,
      flexGrow: 1,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 80,
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      width: 80,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <i className="ri-eye-line fs-5" />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  navigate("/user", {
                    state: {
                      dataId: record.id,
                      page: "details",
                    },
                  });
                  break;
                default:
              }
            },
          }}
          trigger={["click"]}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    full_name: dt.first_name
      ? char.toTitleCase(dt.first_name) + " " + char.toTitleCase(dt.last_name)
      : "N/A",
    gender: dt.gender ? char.toTitleCase(dt.gender) : "N/A",
    email: dt.email ? dt.email : "N/A",
    phone: dt.phone_number ? dt.phone_number : "N/A",
    last: dt.last_login
      ? moment(dt.last_login).format("ddd DD MMM YYYY | HH : mm : ss")
      : "N/A",
    status: dt.is_active ? (
      <span class="badge badge-soft-success">Active</span>
    ) : (
      <span class="badge badge-soft-danger">Not Active</span>
    ),
  }));

  const button = (
    <button className="btn btn-primary" onClick={() => setOpen(true)}>
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New User
    </button>
  );

  return (
    <>
      <UserAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h5 fw-bold text-primary">User Management</p>
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row">
          <TableShared
            setOpen={setOpen}
            loading={loading}
            data={dataItem}
            setData={setData}
            page={page}
            setPage={setPage}
            count={count}
            postsPerPage={postsPerPage}
            setePostPerPage={setePostPerPage}
            setNextPage={setNextPage}
            value={value}
            setValue={setValue}
            defaultColumns={defaultColumns}
            button={button}
            link={"#"}
            showButton={true}
            setLoading={setLoading}
          />
        </div>
      </div>
    </>
  );
};
